import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const createLawSchemaValidation = Yup.object().shape({
  // audience_goal: Yup.number().min(0, 'Menor valor permitido: 0').required('Meta do público-alvo direto obrigatório')
});

export const createLawValidationResolver = yupResolver(createLawSchemaValidation);
